import create from "zustand";

const useAuthStore = create((set, get) => ({
    token: localStorage.getItem("authToken"),
    country: "KWT",
    setToken: (newToken) => {
        localStorage.setItem("authToken", newToken);
        set((state) => ({ token: newToken }));
    },
    removeToken: () => {
        localStorage.removeItem("authToken");
        set({ token: null });
    },
    changeCountry: () => {
        const currentCountry = get().country; // Access current state
        set({ country: currentCountry === "KWT" ? "IN" : "KWT" });
    },
    editCountry: (count) => {
        set({ country: count });
    },
    orderStartDate: null,
    orderEndDate: null,
    setOrderStartDate: (startDate) => set({ orderStartDate: startDate }),
    setOrderEndDate: (endDate) => set({ orderEndDate: endDate }),
}));

export default useAuthStore;
